// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.0074 17.5303C13.7145 17.8232 13.2396 17.8232 12.9467 17.5303L8.17373 12.7574C7.88083 12.4645 7.88083 11.9896 8.17373 11.6967C8.46662 11.4038 8.94149 11.4038 9.23439 11.6967L12.727 15.1893V6.75H3.47703V5.25H14.227V15.1893L17.7197 11.6967C18.0126 11.4038 18.4874 11.4038 18.7803 11.6967C19.0732 11.9896 19.0732 12.4645 18.7803 12.7574L14.0074 17.5303Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
